import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Anchor,
  Button,
  Divider,
  TextInput,
  PasswordInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import { FormWithImage } from "@components/FormWithImage/FormWithImage";
import { useTranslation } from "react-i18next";

export const LoginRoute: FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const navigate = useNavigate();

  const { getInputProps, onSubmit, setFieldError } = useForm({
    initialValues: {
      email: "",
      password: "",
    },
  });

  const handleSubmit = onSubmit(async ({ email, password }) => {
    setIsLoading(true);
    try {
      await signInWithEmailAndPassword(getAuth(), email, password);
      const searchParams = new URLSearchParams(window.location.search);
      const redirect = searchParams.get("redirect") || "/portal";
      window.location.href = redirect;
    } catch (ex) {
      setFieldError("email", " ");
      setFieldError("password", "Invalid email or password.");
    }
    setIsLoading(false);
  });

  return (
    <FormWithImage
      title={t("Login")}
      description={t("Sign in to access your account.")}
      onSubmit={handleSubmit}
    >
      <TextInput
        required
        type="email"
        label={t("Email Address")}
        {...getInputProps("email")}
      />
      <PasswordInput
        required
        label={t("Password")}
        {...getInputProps("password")}
      />
      <Anchor size="sm" onClick={() => navigate("/forgot-password")}>
        {t("Forgot password?")}
      </Anchor>
      <Button type="submit" loading={isLoading}>
        {t("Login")}
      </Button>
      <Divider label={t("or")} labelPosition="center" />
      <Anchor align="center" onClick={() => navigate("/register")}>
        {t("Don't have an account?")} {t("Register")}.
      </Anchor>
    </FormWithImage>
  );
};
